import { defineMessages } from 'react-intl'

const messages = defineMessages({
  cardNumber: {
    id: 'paycomet.card-number',
  },
  expiryDate: {
    id: 'paycomet.expiry-date',
  },
  cvcCode: {
    id: 'paycomet.cvc-code',
  },
  cardHolder: {
    id: 'paycomet.card-holder',
  },
  confirmBooking: {
    id: 'global.confirm-booking',
  },
  changeCreditCard: {
    id: 'payment.change-creditcard',
  },
})

export default messages
